import civs from '../config/civs.json'
import draftOptions from '../config/draftOptions.json'
import classNames from 'classnames';

export function CivSelector({ civ, state, leftSide, allowEmpty, onChange }) {
    const selectedCiv = civs.find(([key, value]) => value.aoe2cm === civ || value.label === civ)?.at(1);

    function handleChange(el) {
        if (onChange)
            onChange(el.target.value);
    }

    const randomFlag = '/civFlags/random.png';

    return (
        <div className={classNames('flex', !!leftSide ? 'flex-row' : 'flex-row-reverse')}>
            {/*<button className='bg-red-500 rounded-full border-zinc-600 w-8 h-8 p-0 hover:bg-red-700'>X</button>*/}

            <img className='w-12 h-8' src={selectedCiv?.originalFlag || randomFlag} />

            <select value={selectedCiv?.aoe2cm} onChange={handleChange} className={classNames('border-solid border-[0.5px] h-8',state == "ban" && "bg-red-200", state == "pick" && "bg-green-200" )}>
                {allowEmpty && <option>(unknown)</option>}
                {civs.sort().map(_civ =>
                    <option value={_civ[1].aoe2cm}>{_civ[1].label}</option>
                    )}
            </select>

            {state && <select value={state} className='border-solid border-zinc-600 border-[0.5px] h-8 w-16'>{draftOptions.map(option => <option value={option}>{option}</option>)}</select>}
        </div>
    )
}
